module.exports = "<section class=\"homeComponent\">\n\t<div class=\"homeContainerImg backImg\">\n\t</div>\n</section>"